// extracted by mini-css-extract-plugin
export var footer = "_qc-0";
export var inherit = "_qc-1";
export var input = "_qc-2";
export var modalContent = "_qc-3";
export var quillEditor = "_qc-4";
export var subtitle = "_qc-5";